import { createActions } from "redux-actions";

export default createActions({
  TOP: {
    FOLLOWCIRCLES: {
      SET: () => ({}),
      SUCCESS: (data) => ({
        data,
      }),
      FAILURE: (error) => ({
        error,
      }),
    },
  },
});
